export var EXCLUDED_DIRECTIONS = ['topLeft', 'topRight', 'top'];